export default "__VITE_ASSET__DIdx$7Np__"